// Saco Lowell Meadows Ring Twister
import React from "react";
import { Input, Row } from "reactstrap";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { ColPrompt, CommonRows, InputRangeRow, RunTimeRow, TravelerSizeSacoRow } from "./index";

export default function MachineSacoRT() {
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   return (
      <>
         <InputRangeRow
            titleProp={"Clock Setting"}
            descriptionProp={"m"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={999999} //some default value
            propertyNameProp={"clockSet"}
            errorDialogueProp={"0-999,999"}
            floatProp={false}
         />
         <RunTimeRow />
         <InputRangeRow
            titleProp={"Spindle Speed"}
            descriptionProp={"rpm"}
            sizeProp={4}
            typeProp={"text"}
            minProp={1}
            maxProp={4000}
            propertyNameProp={"speed"}
            errorDialogueProp={"1-4,000 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Twist Change Gear"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={24}
            maxProp={59}
            propertyNameProp={"changeGear"}
            errorDialogueProp={"24-59"}
            floatProp={false}
         />
         <Row className="mb-2">
            <ColPrompt title={"Twist Constant Gear"} bold={true} description={""} />
            <ColValue size={2}>
               {"Driver:"}
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson?.["driverConstant"] || 21}
                  readOnly
                  disabled
               />
               {errorDivDefinitions?.["driverConstant"] && (
                  <ErrorDiv>
                     {"This is a constant and should never be empty"}
                  </ErrorDiv>
               )}
            </ColValue>
            <ColValue size={2}>
               {"Driven:"}
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson?.["drivenConstant"] || 40}
                  readOnly
                  disabled
               />
               {errorDivDefinitions?.["drivenConstant"] && (
                  <ErrorDiv>
                     {"This is a constant and should never be empty"}
                  </ErrorDiv>
               )}
            </ColValue>
         </Row>
         <TravelerSizeSacoRow />
         <CommonRows />
      </>
   );
}
